export default {
  namespaced: true,
  state () {
    return {
      title: '',
      price: '',
      phone: '',
      coating: 1,
      studdedCleats: true,
      paymentTransfer: true,
      balls: {
        radio: true,
        price: ''
      },
      lighting: {
        radio: true,
        price: ''
      },
      showers: {
        radio: true,
        price: ''
      },
      changingRooms: {
        radio: true,
        price: ''
      },
      manishki: {
        radio: true,
        price: ''
      }
    }
  }
}
